import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout, ConversationRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const NumbersAccessLayout = observer(() => {
  const { usersStore } = useEntitiesContext()

  return (
    <AccessLayout
      name={EnumAccessPageKeys.numbers_settings}
      onAccessDenied={() => {
        const { user } = usersStore

        if (user?.isViewOnlyRole) {
          uiStore.changeRouteViaVue({
            path: `${ConversationRoutes.root}`,
          })
        }
      }}
    />
  )
})
